export const UAN_LOADING = "UAN_LOADING";
export const UAN_SUCCESS = "UAN_SUCCESS";
export const UAN_FAILED = "UAN_FAILED";

export const FETCH_UAN_LOADING = "FETCH_UAN_LOADING";
export const FETCH_UAN_SUCCESS = "FETCH_UAN_SUCCESS";
export const FETCH_UAN_FAILED = "FETCH_UAN_FAILED";

export const ACCEPT_UAN_LOADING = "ACCEPT_UAN_LOADING";
export const ACCEPT_UAN_SUCCESS = "ACCEPT_UAN_SUCCESS";
export const ACCEPT_UAN_FAILED = "ACCEPT_UAN_FAILED";

export const UPLOAD_SALARY_LOADING = "UPLOAD_SALARY_LOADING";
export const UPLOAD_SALARY_SUCCESS = "UPLOAD_SALARY_SUCCESS";
export const UPLOAD_SALARY_FAILED = "UPLOAD_SALARY_FAILED";

export const REMOVE_FILE_LOADING = "REMOVE_FILE_LOADING";
export const REMOVE_FILE_SUCCESS = "REMOVE_FILE_SUCCESS";
export const REMOVE_FILE_FAILED = "REMOVE_FILE_FAILED";

export const UPDATE_UAN_LOADING = "UPDATE_UAN_LOADING";
export const UPDATE_UAN_SUCCESS = "UPDATE_UAN_SUCCESS";
export const UPDATE_UAN_FAILED = "UPDATE_UAN_FAILED";


export const SAVE_UAN_LOADING = "SAVE_UAN_LOADING";
export const SAVE_UAN_SUCCESS = "SAVE_UAN_SUCCESS";
export const SAVE_UAN_FAILED = "SAVE_UAN_FAILED";


export const FETCH_GAP_LOADING = "FETCH_GAP_LOADING";
export const FETCH_GAP_SUCCESS = "FETCH_GAP_SUCCESS";
export const FETCH_GAP_FAILED = "FETCH_GAP_FAILED";

export const GAP_REASON_LOADING = "GAP_REASON_LOADING";
export const GAP_REASON_SUCCESS = "GAP_REASON_SUCCESS";
export const GAP_REASON_FAILED = "GAP_REASON_FAILED";

// export const ADDRESS_ADD_LOADING = "ADDRESS_ADD_LOADING";
// export const ADDRESS_ADD_SUCCESS = "ADDRESS_ADD_SUCCESS";
// export const ADDRESS_ADD_FAILED = "ADDRESS_ADD_FAILED";

// export const ADDRESS_REMOVE_LOADING = "ADDRESS_REMOVE_LOADING";
// export const ADDRESS_REMOVE_SUCCESS = "ADDRESS_REMOVE_SUCCESS";
// export const ADDRESS_REMOVE_FAILED = "ADDRESS_REMOVE_FAILED";

// export const ADDRESS_UPDATE_QUESTION_LOADING = "ADDRESS_UPDATE_QUESTION_LOADING";
// export const ADDRESS_UPDATE_QUESTION_SUCCESS = "ADDRESS_UPDATE_QUESTION_SUCCESS";
// export const ADDRESS_UPDATE_QUESTION_FAILED = "ADDRESS_UPDATE_QUESTION_FAILED";

// export const ADDRESS_SAVE_LOADING = "ADDRESS_SAVE_LOADING";
// export const ADDRESS_SAVE_SUCCESS = "ADDRESS_SAVE_SUCCESS";
// export const ADDRESS_SAVE_FAILED = "ADDRESS_SAVE_FAILED";

// export const ADDRESS_VALIDATION_LOADING = "ADDRESS_VALIDATION_LOADING";
// export const ADDRESS_VALIDATION_SUCCESS = "ADDRESS_VALIDATION_SUCCESS";
// export const ADDRESS_VALIDATION_FAILED = "ADDRESS_VALIDATION_FAILED";


